import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SidebarComponent } from '@/layouts/sidebar/sidebar.component';
import { LayoutService } from '@/shared/services/ui';

@Component({
  selector: 'cis-sidebar-wrapper',
  imports: [SidebarComponent],
  template: `
    @let sidebarVisible = layoutService.sidebarVisible();
    <div
      class="fixed mt-7 z-2 h-screen transition-all transition-duration-300"
      [style.width]="sidebarVisible ? '18rem' : '5rem'"
      [style.background-color]="'white'">
      <div class="flex flex-column h-full w-full overflow-hidden">
        <cis-sidebar />
      </div>
    </div>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarWrapperComponent {
  protected readonly layoutService = inject(LayoutService);
}
